module.exports = __webpack_public_path__ + "static/logo-vertical-dark-300x246-1bf202fa87fec0697ca942d0b2d26d5f.png";